import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import Image from 'components/Common/Image'

const ImageWrapper = styled.div`
  position: relative;
  flex-shrink: 0;

  ${mediaQueryUp.tablet} {
    width: 100%;
  }
`

const CardImage = styled(Image)`
  height: ${rem(100)};
  width: ${rem(110)}; 
  border-radius: ${props => props.theme.borderRadius.M};
  object-fit: cover;

  ${mediaQueryUp.tablet} {
    height: ${rem(332)};
    width: 100%;
    border-radius: ${props => props.theme.borderRadius.L};
  }
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
`

const CardRoot = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${rem(16)};
  align-items: center;
  padding: ${rem(16)} 0;
  border-bottom: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};

  &:last-child {
    border-bottom: none;
  }

  &:first-child {
    border-top: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  }


  ${mediaQueryUp.tablet} {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    border-bottom: none;
  }
`

interface Props {
  imageSrc: string
  imageAlt: string
  title: string
  description: string
  /**
   * Optional overlay content rendered on top of the image.
   * The caller is responsible for positioning via absolute positioning.
   */
  imageOverlay?: React.ReactNode
}

function LuxPlusLandingBenefitCard(props: Props) {
  const { imageSrc, imageAlt, title, description, imageOverlay } = props

  return (
    <CardRoot>
      <ImageWrapper>
        <CardImage id={imageSrc} alt={imageAlt} />
        {imageOverlay}
      </ImageWrapper>
      <CardContent>
        <Heading variant="heading5">{title}</Heading>
        <BodyText variant="small" colour="light-foreground-alt">{description}</BodyText>
      </CardContent>
    </CardRoot>
  )
}

export default LuxPlusLandingBenefitCard
